/** Password every preloaded sample patient shares — public, documented, and only checked client-side by the mock login. The whole "login step" is theatre so the flow feels like a real SMART sign-in; the real auth is the patient session cookie. */
export const DEMOPASS = "demopass";

/** Message surfaced on the Synthetic Hospital login card when the client-side password check fails. */
export const WRONG_PASSWORD_MESSAGE = "Wrong password. Every synthetic patient uses `demopass`.";

/** Hard cap on a single uploaded bundle. Larger bundles must be split before upload. */
export const MAX_UPLOAD_BYTES = 50_000_000;
